import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { map, of, tap } from 'rxjs';
import { DEFAULT_TENANT_LICENSE_AGENT_TO_CHECK } from '../../../shared/utils';
import { LicenseService } from '../../license/data-access-license/service/license.service';

export const ChatGuard: CanActivateFn | CanActivateChildFn = () => {
  const router = inject(Router);

  return inject(LicenseService)
    .isChatActiveForTenantAgent(DEFAULT_TENANT_LICENSE_AGENT_TO_CHECK)
    .pipe(
      map((isChatVisible) => isChatVisible),
      tap((hasAccess: boolean) => {
        if (!hasAccess) {
          router.navigate(['/']);
        }

        return of(hasAccess);
      }),
    );
};
